<script setup lang="ts">
import CornerLogo from '@/components/CornerLogo.vue';
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import { useSeoMeta } from '@unhead/vue';
import { Head } from 'vike-vue/Head';

useSeoMeta({
  title: 'About Us - Parsec Skateboards',
});
</script>

<template>
  <Head>
    <title>About Us - Parsec Skateboards</title>
    <meta name="description" content="About Us" />
  </Head>

  <main>
    <Header />

    <section class="relative bg-primary md:!pt-20 col-span-12 rounded-lg flex justify-center">
      <CornerLogo class="hidden md:block" />

      <div class="max-w-4xl w-full text-content">
        <h1 v-anchor>About Us</h1>

        <h2 v-anchor>Our Vision</h2>
        <p>Empower electric skateboards to become the de facto option for short range commute.</p>

        <h2 v-anchor>Our Promise</h2>
        <p>
          Parsec will relentlessly pursuit to bring purposeful innovation, breathtaking design, meticulous engineering,
          and unparalleled reliability to this industry.
        </p>

        <h2 v-anchor>Our Team</h2>

        <h3 v-anchor>Daniel Kwan - Founder</h3>
        <p>
          First started reviewing electric skateboards in 2017, Daniel Kwan has helped countless companies succeed
          through his detailed, in-depth review videos on their products.
        </p>
        <p>
          Over the years, Daniel has personally tested and reviewed hundreds of boards and have condensed down his own
          criteria when it comes to an e-skate product, focusing primarily on whether the product has utilized the form
          factor properly or not.
        </p>
        <p>
          However, with the arms race for ever faster, bigger, and heavier boards in recent years, he decided that this
          is the wrong direction for the industry, and if nobody within the industry recognises the necessity, he'll
          just do it himself.
        </p>
        <p>
          With likely the most models of electric skateboards tested than anyone else on the planet, Daniel has all the
          pros and cons he wants or wishes to solve and have curated a line of products using his vast knowledge and
          experience to share with the world.
        </p>
      </div>
    </section>

    <Footer />
  </main>
</template>
